import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getAllAdsLoading: false,
  getAllAdsFailed: false,
  getAllAdsReject: false,
  getAllAdsMessage: [],
  allADS: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_ADS_LOADING: {
      return {
        ...state,
        getAllAdsLoading: true,
        getAllAdsFailed: false,
        getAllAdsReject: false,
        getAllAdsMessage: [],
        allADS: [],
      };
    }
    case actionTypes.GET_ALL_ADS_SUCCESS: {
      return {
        ...state,
        getAllAdsLoading: false,
        getAllAdsFailed: false,
        getAllAdsReject: false,
        getAllAdsMessage: [],
        allADS: action.payload,
      };
    }
    case actionTypes.GET_ALL_ADS_FAILED: {
      return {
        ...state,
        getAllAdsLoading: false,
        getAllAdsFailed: true,
        getAllAdsReject: false,
        getAllAdsMessage: [],
        allADS: [],
      };
    }
    case actionTypes.GET_ALL_ADS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getAllAdsLoading: false,
        getAllAdsFailed: false,
        getAllAdsReject: true,
        getAllAdsMessage: message,
        allADS: [],
      };
    }

    default:
      return state;
  }
};
